import deductionplans from "./deductionplans.component";
import deductionplansUrls from "./deductionplans.urls";
import DeductionplansTransforms from "./deductionplans.transforms";

const deductionplansModule = angular
  .module("app.components.deductionplans", [])
  .component("deductionplansPage", deductionplans)
  .service("DeductionplansTransforms", DeductionplansTransforms)
  .config(deductionplansUrls);

export default deductionplansModule;



// WEBPACK FOOTER //
// ./src/pages/deductionplans/deductionplans.module.js